var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7806 8.53061L11.0306 15.2806C10.8899 15.4213 10.699 15.5004 10.5 15.5004C10.301 15.5004 10.1101 15.4213 9.96937 15.2806C9.82864 15.1399 9.74958 14.949 9.74958 14.75C9.74958 14.551 9.82864 14.3601 9.96937 14.2194L15.4397 8.74999H0.75C0.551088 8.74999 0.360322 8.67097 0.21967 8.53032C0.0790178 8.38967 0 8.1989 0 7.99999C0 7.80108 0.0790178 7.61031 0.21967 7.46966C0.360322 7.32901 0.551088 7.24999 0.75 7.24999H15.4397L9.96937 1.78061C9.82864 1.63988 9.74958 1.44901 9.74958 1.24999C9.74958 1.05097 9.82864 0.860095 9.96937 0.719365C10.1101 0.578634 10.301 0.499573 10.5 0.499573C10.699 0.499573 10.8899 0.578634 11.0306 0.719365L17.7806 7.46936C17.8504 7.53902 17.9057 7.62174 17.9434 7.71278C17.9812 7.80383 18.0006 7.90143 18.0006 7.99999C18.0006 8.09855 17.9812 8.19615 17.9434 8.2872C17.9057 8.37824 17.8504 8.46096 17.7806 8.53061Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e74bc10c09588feda6a7a4ad7bda03a2.svg";
export { ForwardRef as ReactComponent };